import React from 'react';
import "./Footer.css";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const companyName = "Altrange Private Limited";
  return (
    <div className='footer-wrapper'>
        <div><p className='text-center fw-bold' style={{color:'#fff',lineHeight:'3'}}> &copy; {currentYear} {companyName}</p></div>
      
    </div>
  )
}

export default Footer
